import UserFeedback from "../user/user.feedback";
import AdminFeedback from "../admin/admin.feedback";

export const knownMessages = {
  // ADMIN
  [AdminFeedback.DEVICE_REMOVE_FAILED]: "Kunne ikke fjerne enhet.",
  [AdminFeedback.DEVICE_REMOVED]: "Enheten ble slettet.",
  [AdminFeedback.DEVICE_APROVED]: "Enheten ble godkjent.",
  [AdminFeedback.DEVICE_APROVE_FAILED]: "Kunne ikke godkjenne enheten.",
  [AdminFeedback.API_KEY_EDIT_FAILED]: "Kunne ikke oppdatere API-nøkkel.",
  [AdminFeedback.API_KEY_EDITED]: "API-nøkkel er oppdatert.",
  [AdminFeedback.API_KEY_REMOVE_FAILED]: "Kunne ikke fjerne API-nøkkel.",
  [AdminFeedback.API_KEY_REMOVED]: "API-nøkkel ble slettet.",
  [AdminFeedback.API_KEY_CREATED]: "API-nøkkel ble opprettet.",
  [AdminFeedback.API_KEY_CREATE_FAILED]: "Feil ved opprettelse av ApiKey",
  [AdminFeedback.AUTHORIZATIONS_UPDATED]:
    "Kunne ikke oppdatere brukerrettigheter.",
  [AdminFeedback.AUTHORIZATIONS_UPDATE_FAILED]:
    "Brukerrettigheter ble oppdatert.",
  [AdminFeedback.USER_LIST_FAILED]: "Kunne ikke hente brukere.",
  // USER
  [UserFeedback.LOGIN_FAILED]: "Noe gikk galt med innloggingen.",
  [UserFeedback.DEVICE_NOT_VERIFIED]:
    "Noe gikk galt med innloggingen. Har du sjekket telefonen din?",
  [UserFeedback.USERNAME_MISSING]: "Brukernavn mangler",
  [UserFeedback.PASSWORD_CHANGED]: "Passordet ble endret. Sjekk telefonen din.",
  [UserFeedback.PASSWORD_RESET_FAILED]:
    "Noe gikk galt ved tilbakestilling av passord, prøv igjen senere eller kontakt support.",
  [UserFeedback.API_KEY_GET_FAILED]: "Kunne ikke hente API-nøkler.",
  [UserFeedback.API_KEY_EDIT_FAILED]: "Kunne ikke oppdatere API-nøkkel.",
  [UserFeedback.API_KEY_EDIT_UPDATED]: "API-nøkkel er oppdatert.",
  [UserFeedback.CREATE_NEW_API_KEY_FAILED]: "Kunne ikke opprette ny API-nøkkel.",
  [UserFeedback.CREATE_NEW_API_KEY_SUCCESS]: "Ny API-nøkkel er opprettet.",
  [UserFeedback.DELETE_API_KEY_FAILED]: "Kunne ikke slette API-nøkkel.",
  [UserFeedback.DELETE_API_KEY_SUCCESS]: "API-nøkkel er slettet.",
  [UserFeedback.DEVICES_GET_FAILED]: "Kunne ikke hente enheter.",
  [UserFeedback.DEVICE_REMOVE_FAILED]: "Kunne ikke fjerne enhet.",
  [UserFeedback.DEVICE_REMOVED]: "Enheten ble slettet.",
  [UserFeedback.PASSWORD_CHANGED]: "Passordet ble endret.",
  [UserFeedback.PASSWORD_CHANGE_FAILED]: "Noe gikk galt ved endring av passord."
};
